import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { userProfileApi } from 'services/profile';



// Async action to fetch user profile
// 'userProfile/fetchUserProfile'---->>>this-name*userProfile/fetchUserProfile*--only-unique-identification--like-your--slice-name-and-store-name--
export const fetchUserProfile = createAsyncThunk('userProfile/fetchUserProfile',//--only-unique-identification-
    async (plantId, { rejectWithValue }) => {
        try {
            const res = await userProfileApi({ plantId });
            if (res?.status === 200) {
                return res.data; // Return data on success
            } else {
                return rejectWithValue('Failed to fetch user profile'); // Handle error
            }
        } catch (error) {
            return rejectWithValue(error.message); // Handle network errors
        }
    }
);

const userProfileSlice = createSlice({
    name: 'userProfile',
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {
        resetUserProfile: (state) => {
            state.user = null;
            state.loading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchUserProfile.pending, (state) => {
                state.loading = true; // When the API call starts
            })
            .addCase(fetchUserProfile.fulfilled, (state, action) => {
                state.loading = false;
                state.user = action.payload; // Store the user data
            })
            .addCase(fetchUserProfile.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Something went wrong user';
            });
    },
});
export const { resetUserProfile } = userProfileSlice.actions;
export default userProfileSlice.reducer;
